import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-offers-tags-dialog',
  templateUrl: './offer-initial-csv-dialog.component.html',
  styleUrls: ['./offer-initial-csv-dialog.component.scss']
})
export class OfferInitialCsvDialogComponent implements OnInit {
  public csvOffer = {};
  public csvOfferKeys = [];

  constructor(
    public translate: TranslateService,
    public dialogRef: MatDialogRef<{}>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.csvOffer = this.data.csvOffer;
    if (this.csvOffer) {
      this.csvOfferKeys = Object.keys(this.data.csvOffer);
    }
  }

  close() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-list/offer-initial-csv/offer-initial-csv-dialog.component.ts